import React, { useEffect, useState } from 'react'

import { twMerge } from 'tailwind-merge'

import Icon from '@components/Icon'
import * as translator from '@helpers/translator'

export interface WeatherProps {
  temp?: number
  iconId?: string
  translationId?: string
  className?: string
  color?: string
}

const Weather = ({
  temp,
  iconId,
  translationId,
  className,
  color,
}: WeatherProps) => {
  if (!temp) {
    return null
  }

  const [weatherIcon, setWeatherIcon] = useState<string | null>(null)
  const translation = `OWM${translationId}`

  const translationValue = translator.trans(
    translator[translation as keyof typeof translator],
  )

  useEffect(() => {
    if (iconId) {
      const iconName = `weather_${iconId}`
      setWeatherIcon(iconName)
    }
  }, [iconId])

  return (
    <>
      <div className={twMerge('flex items-center gap-x-2.5', className)}>
        {weatherIcon && <Icon name={weatherIcon} size={24} />}
        <div className={twMerge('flex flex-col text-sm font-medium', color)}>
          {temp && (
            <span>
              {temp}
              <sup>°</sup>
            </span>
          )}
          {translationValue && (
            <span title={translationValue} className="first-letter:uppercase">
              {translationValue}
            </span>
          )}
        </div>
      </div>
    </>
  )
}

export default Weather
